export const getProgressPercentage = (duration, currentTime) => Number(((100 / duration) * currentTime).toFixed(3));
